module.exports = __webpack_public_path__ + "static/img/newanli-19.611538da.jpg";